module.exports = __webpack_public_path__ + "img/intro-title-sr.92df96ef.gif";